module.exports = __webpack_public_path__ + "img/badge-money-back.cad8e661.svg";